module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document-renewal-detail"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('a', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(_vm._s(_vm.backPageLabel))])]), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Document Renewal Detail')))])])]), (_vm.notify) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert",
    class: _vm.notify.danger ? 'alert-danger' : 'alert-success'
  }, [_c('span', [_vm._v(_vm._s(_vm.notify.message))])])])]) : _vm._e(), (_vm.forbidden) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('document_renewal.message.forbidden')))])])])]) : _vm._e(), (_vm.searchCallbackFlag && _vm.renewal) ? _c('div', {
    staticClass: "form-horizontal"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.renewal.attributes['document-type-i18n']) + "（" + _vm._s(_vm.renewal.attributes['user-name']) + " " + _vm._s(_vm.renewal.attributes['user-firstname']) + "）")]), _c('hr'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "renewal-file text-center"
  }, [(_vm.renewal.attributes['is-image']) ? _c('img', {
    attrs: {
      "src": _vm.fileUrl
    }
  }) : _c('iframe', {
    attrs: {
      "src": _vm.fileUrl + '#toolbar=0&scrollbar=1&view=FitH,top',
      "type": "application/pdf"
    }
  })], 1), _c('p', {
    staticClass: "text-center margin-top"
  }, [_c('a', {
    attrs: {
      "href": _vm.fileUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.renewal.attributes['file-name']))])])]), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v(_vm._s(_vm.$t('document_renewal.label.shop_name')))]), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.renewal.attributes['shop-name']))])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v(_vm._s(_vm.$t('document_renewal.label.submitted_at')))]), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.renewal.attributes['created-at-format']))])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v(_vm._s(_vm.$t('document_renewal.label.status')))]), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_c('span', {
    staticClass: "label status-label",
    class: _vm.statusClass
  }, [_vm._v(_vm._s(_vm.renewal.attributes['status-i18n']))])])])]), (_vm.renewal.attributes['status'] === 'rejected') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v(_vm._s(_vm.$t('document_renewal.label.review_comment')))]), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.renewal.attributes['review-comment']))])])]) : _vm._e(), (_vm.renewal.attributes['status'] !== 'submitted') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v(_vm._s(_vm.$t('document_renewal.label.reviewed_at')))]), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.renewal.attributes['reviewed-at-format']))])])]) : _vm._e(), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v(_vm._s(_vm.$t('document_renewal.label.current_deadline')))]), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.renewal.attributes['current-deadline-date'] || '-'))])])]), (_vm.renewal.attributes['status'] === 'submitted') ? _c('div', [_c('hr'), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v(_vm._s(_vm.$t('document_renewal.label.new_deadline')))]), _c('div', {
    staticClass: "col-sm-7 text-left"
  }, [_c('el-date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deadline_date),
      expression: "deadline_date"
    }],
    attrs: {
      "placeholder": "yyyy-mm-dd"
    },
    domProps: {
      "value": (_vm.deadline_date)
    },
    on: {
      "input": function($event) {
        _vm.deadline_date = $event
      }
    }
  })], 1)]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-5 col-sm-7"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    class: _vm.saving ? 'disabled' : '',
    on: {
      "click": _vm.confirm
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('document_renewal.button.confirm')))])])])]), _c('hr'), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v(_vm._s(_vm.$t('document_renewal.label.review_comment')))]), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.review_comment),
      expression: "review_comment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": _vm._s(_vm.review_comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.review_comment = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-5 col-sm-7"
  }, [_c('a', {
    staticClass: "btn btn-danger",
    class: _vm.saving ? 'disabled' : '',
    on: {
      "click": _vm.reject
    }
  }, [_c('i', {
    staticClass: "fa fa-undo"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('document_renewal.button.reject')))])])])])]) : _vm._e()])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(_vm._s(_vm.$t('document_renewal.button.back')))])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ed69ccb0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/document-renewal-detail.pug
// module id = 930
// module chunks = 1